import { fetchBaseQuery,createApi } from "@reduxjs/toolkit/query/react";
import { setLogout, setShowSessionConflict, setSessionExpired } from "../redux/authSlice";

export const getApiBaseUrl = () => {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1" || host.startsWith("192.168.")) {
      return "http://localhost:9000/api";
    }
  }
  return "https://api.thequickpayme.com/api";
};

const baseQuery = fetchBaseQuery({
  baseUrl: getApiBaseUrl(),
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    let token = getState()?.auth?.userInfo?.token;
    if (!token) {
      try {
        const stored = JSON.parse(localStorage.getItem("userInfo") || "{}");
        token = stored?.token;
      } catch (e) {}
    }
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  }
});

const baseQueryWithAuth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error) {
    if (result.error.status === 401) {
      if (result.error.data?.actionRequired) {
        api.dispatch(setShowSessionConflict(result.error.data?.message));
      } else {
        // Token expired, missing or invalid -> notify session expiry and strictly log out
        const errorMsg = result.error.data?.message || "Your session has expired. Please log in again.";
        api.dispatch(setSessionExpired({ message: errorMsg }));
        api.dispatch(setLogout());
      }
      return result;
    }
  }
  return result;
};

export const apiSlice = createApi({
    baseQuery:baseQueryWithAuth,
    tagTypes: [
      'Users',
      'UserProfile',
      'UserManagementSummary',
      'CommissionRules',
      'UserOverrides',
      'OverrideHistory',
      'TodayTransactions',
      'CommissionLedger',
      'Invitations',
      'PendingApprovals',
      'Permissions',
      'RolePermissions',
      'AdminModules',
      'UserPermissions',
      'PermissionAuditLogs',
      'QrPgConfig',
      'QrPgTransactions',
      'AdminQrPgConfigs',
      'AdminQrPgTransactions',
      'Dashboard',
      'Settlements',
      'SavedBankAccounts',
      'Notifications',
      'SystemSettings',
      'Commissions',
      'UserManagement',
      'Reconciliation',
      'PayoutConfig',
      'PayinHistory',
      'CardToBankConfig',
      'CardToBankCategories',
      'CardToBankFeeStructure',
      'BbpsCategories',
      'BbpsBillers',
      'BbpsBiller',
      'BbpsDeposit',
      'BbpsTransactions',
      'AdminBbpsBillers',
      'BbpsCharges',
      'NotificationSubscribers',
      'NotificationTemplates',
      'UserNotifications',
      'UserNotificationsCount',
      'Disputes',
      'UserDisputes',
      'PosDevices',
      'PosTransactions',
      'AiAgentSettings'
    ],
    endpoints:(builder)=>({}),
})